<template>
  <div class="mb-md-5 mb-2">
    <div class="sub-title mb-2">Orders</div>
    <div class="card card-table">
      <div class="card-body p-0">
        <table v-if="orders" class="table table-hover table-orders">
          <thead>
            <tr>
              <th colspan="2" scope="col">Projectreferentie</th>
              <th class="text-right" scope="col">Leverdatum</th>
              <th scope="col">Bedrag (Ex. BTW)</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="orders.length">
              <tr v-for="order in orders" :key="order.id" @click="viewOrderDetails(order)" class="cursor-pointer">
                <td class="order-id">
                  #{{ order.id }}
                </td>
                <td class="order-reference">
                  {{ order.reference }}
                </td>
                <td class="order-date text-right">{{ order.pickup_date }}</td>
                <td v-html="order.totalPrice"></td>
                <td class="order-date">
                  {{ order.status }}
                </td>
              </tr>
            </template>
            <template v-else-if="!loadingOrders">
              <tr>
                <td colspan="5">
                  Geen orders gevonden.
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="loadingOrders" class="loading-orders text-center">
          <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
        </div>
      </div>

      <div class="card-footer text-center">
        <div v-if="hasMoreOrders" @click="loadMore" class="load-more">
          <font-awesome-icon class="font-awesome-icon" icon="plus-circle"/>
          Meer laden
        </div>
        <div v-else>
          Geen andere orders om te laden
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CLEAR_ORDERS, FETCH_ORDERS, SEARCH_ORDERS } from '../../store/types'

  export default {
    props: ['search'],
    data() {
      return {
        offset: 0
      }
    },
    methods: {
      loadMore() {
        this.offset += 5
        // Fetch more orders
        this.$store.dispatch(FETCH_ORDERS, {
          search: this.search,
          offset: this.offset
        })
      },
      viewOrderDetails(order) {
        this.$router.push({ name: 'order-details', params: { order: order.id } })
      }
    },
    watch: {
      search() {
        this.$store.dispatch(SEARCH_ORDERS, {
          search: this.search,
          offset: 0
        })
      }
    },
    computed: {
      orders() {
        return !this.$store.getters.orders ? [] : this.$store.getters.orders
      },
      loadingOrders() {
        return this.$store.getters.loadingOrders
      },
      hasMoreOrders() {
        return this.$store.getters.hasMoreOrders
      }
    },
    created() {
      this.$store.dispatch(CLEAR_ORDERS)
      this.$store.dispatch(FETCH_ORDERS, {
        search: this.search,
        offset: this.offset
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
